/**
 * 画像・音声ファイルの受け入れ判定。
 *
 * MIME の厳密な一覧で判定すると、ブラウザごとの表記差（WebKit は WAV を
 * audio/x-wav、iOS の写真ピッカーは type を空で返す）で正しいファイルが弾かれる。
 * 種別（image/*, audio/*）で判定し、type が空のときだけ拡張子で補う。
 * 実際にデコードできるかはブラウザが後段で判定する。
 */

const IMAGE_EXTENSIONS = /\.(jpe?g|png|webp|gif|heic|heif)$/i;
const AUDIO_EXTENSIONS = /\.(mp3|wav|ogg|m4a|aac|flac)$/i;

function matches(file: File, family: 'image' | 'audio', extensions: RegExp): boolean {
  if (file.type) return file.type.startsWith(`${family}/`);
  return extensions.test(file.name);
}

export function isImageFile(file: File): boolean {
  return matches(file, 'image', IMAGE_EXTENSIONS);
}

export function isAudioFile(file: File): boolean {
  return matches(file, 'audio', AUDIO_EXTENSIONS);
}
